//#region node_modules/.pnpm/sp-supermarquee@3.1.2/node_modules/sp-supermarquee/src/core/Template.js
var templateHorizontal = document.createElement("template");
var templateVertical = document.createElement("template");
function interpolate(template, params) {
	const replaceTags = {
		"&": "&amp;",
		"<": "&lt;",
		">": "&gt;",
		"(": "%28",
		")": "%29"
	};
	const safeInnerHTML = (text) => text.toString().replace(/[&<>\(\)]/g, (tag) => replaceTags[tag] || tag);
	const keys = Object.keys(params);
	const keyVals = Object.values(params).map(safeInnerHTML);
	return new Function(...keys, `return \`${template}\``)(...keyVals);
}
var instanceId = "not-used";
templateHorizontal.innerHTML = `
    <style>
        .fader-left-${instanceId} {
            --faderLeft: 0%;
            --faderLeftGradient : linear-gradient(to right, #ffffff, transparent);
        }
        .fader-left-${instanceId}::before {
            display: block;
            content: '';
            width: var(--faderLeft);
            height: 100%;
            position: absolute;
            top: 0;
            z-index: 1;
            pointer-events: none;
            left: 0;
            background-image:  var( --faderLeftGradient );
        }
        .fader-right-${instanceId} {
            --faderRight: 0%;
            --faderRightGradient : linear-gradient(to right, #ffffff, transparent);
        }
        .fader-right-${instanceId}::after {
            display: block;
            content: '';
            width: var(--faderRight);
            height: 100%;
            position: absolute;
            top: 0;
            z-index: 1;
            pointer-events: none;
            right: 0;
            background-image:  var( --faderRightGradient );
        }
    </style>
    <div data-id="supermarquee-container"
         data-instance-id="${instanceId}"    
         style="width: 100%; display: block;pointer-events: all; overflow: hidden;visibility: hidden;">
        <div data-id="supermarquee-perspective">
            <div data-id="supermarquee-outer-wrapper"
                 style="transform-style: preserve-3d;-webkit-transform-style: preserve-3d;overflow: hidden;box-sizing: content-box;">
                <div data-id="supermarquee-inner-container"
                     style="display: flex;flex: 0 0 auto;white-space: nowrap;height: inherit;">
                    <div data-id="supermarquee-item"
                         style="display: flex;flex: 0 0 auto;"></div>
                    <div data-id="supermarquee-item-clone"
                         style="display: flex;flex: 0 0 auto;"></div>
                </div>
            </div>
        </div>
    </div>
`;
var tmplHori = "<style>\n        .fader-left-${instanceId} {\n            --faderLeft: 0%;\n            --faderLeftGradient : linear-gradient(to right, #ffffff, transparent);\n        }\n        .fader-left-${instanceId}::before {\n            display: block;\n            content: '';\n            width: var(--faderLeft);\n            height: 100%;\n            position: absolute;\n            top: 0;\n            z-index: 1;\n            pointer-events: none;\n            left: 0;\n            background-image:  var( --faderLeftGradient );\n        }\n        .fader-right-${instanceId} {\n            --faderRight: 0%;\n            --faderRightGradient : linear-gradient(to right, #ffffff, transparent);\n        }\n        .fader-right-${instanceId}::after {\n            display: block;\n            content: '';\n            width: var(--faderRight);\n            height: 100%;\n            position: absolute;\n            top: 0;\n            z-index: 1;\n            pointer-events: none;\n            right: 0;\n            background-image:  var( --faderRightGradient );\n        }\n    </style>\n    <div data-id=\"supermarquee-container\"\n         data-instance-id=\"${instanceId}\"    \n         style=\"width: 100%; display: block;pointer-events: all; overflow: hidden;visibility: hidden;\">\n        <div data-id=\"supermarquee-perspective\">\n            <div data-id=\"supermarquee-outer-wrapper\"\n                 style=\"transform-style: preserve-3d;-webkit-transform-style: preserve-3d;overflow: hidden;box-sizing: content-box;\">\n                <div data-id=\"supermarquee-inner-container\"\n                     style=\"display: flex;flex: 0 0 auto;white-space: nowrap;height: inherit;\">\n                    <div data-id=\"supermarquee-item\"\n                         style=\"display: flex;flex: 0 0 auto;\"></div>\n                    <div data-id=\"supermarquee-item-clone\"\n                         style=\"display: flex;flex: 0 0 auto;\"></div>\n                </div>\n            </div>\n        </div>\n    </div>";
function getHorizontal(data) {
	const ih = interpolate(tmplHori.toString().trim(), data);
	const tmpl = document.createElement("template");
	tmpl.innerHTML = ih;
	return tmpl;
}
templateVertical.innerHTML = `
    <style>
        .fader-top-${instanceId} {
            --faderTop: 0%;
            --faderTopGradient : linear-gradient(180deg, transparent, #ffffff);
        }
        .fader-top-${instanceId}::before {
            display: block;
            content: '';
            height: var(--faderTop);
            top: 0;
            left : 0;
            right: 0;
            position: absolute;
            z-index: 1;
            pointer-events: none;
            background-image: var( --faderTopGradient );
        } 
        .fader-bottom-${instanceId} {
            --faderBottom: 0%;
            --faderBottomGradient : linear-gradient(180deg, transparent, #ffffff);
        }
        .fader-bottom-${instanceId}::after {
            display: block;
            content: '';
            height: var(--faderBottom);
            bottom: 0;
            left : 0;
            right: 0;
            position: absolute;
            z-index: 1;
            pointer-events: none;
            background-image: var( --faderBottomGradient );
        }  
    </style>
    
    <div data-id="supermarquee-container"
         style="width: 100%; display: block;pointer-events: all;height: inherit;overflow: hidden;visibility: hidden;">
        <div data-id="supermarquee-perspective">        
            <div data-id="supermarquee-outer-wrapper"
                 style="transform-style: preserve-3d;-webkit-transform-style: preserve-3d;overflow: hidden;box-sizing: content-box;width: inherit;height: inherit;">
                <div data-id="supermarquee-inner-container"
                     style="display: inline-block;width: inherit;max-height: 100%;height: inherit;">
                    <div data-id="supermarquee-item" style="display: block;"></div>
                    <div data-id="supermarquee-item-clone" style="display: block;"></div>
                </div>
            </div>
        </div>
    </div>
`;
var tmplVert = "<style>\n        .fader-top-${instanceId} {\n            --faderTop: 0%;\n            --faderTopGradient : linear-gradient(180deg, transparent, #ffffff);\n        }\n        .fader-top-${instanceId}::before {\n            display: block;\n            content: '';\n            height: var(--faderTop);\n            top: 0;\n            left : 0;\n            right: 0;\n            position: absolute;\n            z-index: 1;\n            pointer-events: none;\n            background-image: var( --faderTopGradient );\n        } \n        .fader-bottom-${instanceId} {\n            --faderBottom: 0%;\n            --faderBottomGradient : linear-gradient(180deg, transparent, #ffffff);\n        }\n        .fader-bottom-${instanceId}::after {\n            display: block;\n            content: '';\n            height: var(--faderBottom);\n            bottom: 0;\n            left : 0;\n            right: 0;\n            position: absolute;\n            z-index: 1;\n            pointer-events: none;\n            background-image: var( --faderBottomGradient );\n        }  \n    </style>\n    \n    <div data-id=\"supermarquee-container\"\n         style=\"width: 100%; display: block;pointer-events: all;height: inherit;overflow: hidden;visibility: hidden;\">\n        <div data-id=\"supermarquee-perspective\">        \n            <div data-id=\"supermarquee-outer-wrapper\"\n                 style=\"transform-style: preserve-3d;-webkit-transform-style: preserve-3d;overflow: hidden;box-sizing: content-box;width: inherit;height: inherit;\">\n                <div data-id=\"supermarquee-inner-container\"\n                     style=\"display: inline-block;width: inherit;max-height: 100%;height: inherit;\">\n                    <div data-id=\"supermarquee-item\" style=\"display: block;\"></div>\n                    <div data-id=\"supermarquee-item-clone\" style=\"display: block;\"></div>\n                </div>\n            </div>\n        </div>\n    </div>";
function getVertical(data) {
	const ih = interpolate(tmplVert.toString().trim(), data);
	const tmpl = document.createElement("template");
	tmpl.innerHTML = ih;
	return tmpl;
}
//#endregion
//#region node_modules/.pnpm/sp-supermarquee@3.1.2/node_modules/sp-supermarquee/src/core/Util.js
var Util = {
	forceNbspInHtml: function(htmlString) {
		var regEx = /* @__PURE__ */ new RegExp("( )(?!([^<]+)?>)", "gi");
		return htmlString.replace(regEx, "&nbsp;");
	},
	generateUUID: function() {
		const _lut = [
			"00",
			"01",
			"02",
			"03",
			"04",
			"05",
			"06",
			"07",
			"08",
			"09",
			"0a",
			"0b",
			"0c",
			"0d",
			"0e",
			"0f",
			"10",
			"11",
			"12",
			"13",
			"14",
			"15",
			"16",
			"17",
			"18",
			"19",
			"1a",
			"1b",
			"1c",
			"1d",
			"1e",
			"1f",
			"20",
			"21",
			"22",
			"23",
			"24",
			"25",
			"26",
			"27",
			"28",
			"29",
			"2a",
			"2b",
			"2c",
			"2d",
			"2e",
			"2f",
			"30",
			"31",
			"32",
			"33",
			"34",
			"35",
			"36",
			"37",
			"38",
			"39",
			"3a",
			"3b",
			"3c",
			"3d",
			"3e",
			"3f",
			"40",
			"41",
			"42",
			"43",
			"44",
			"45",
			"46",
			"47",
			"48",
			"49",
			"4a",
			"4b",
			"4c",
			"4d",
			"4e",
			"4f",
			"50",
			"51",
			"52",
			"53",
			"54",
			"55",
			"56",
			"57",
			"58",
			"59",
			"5a",
			"5b",
			"5c",
			"5d",
			"5e",
			"5f",
			"60",
			"61",
			"62",
			"63",
			"64",
			"65",
			"66",
			"67",
			"68",
			"69",
			"6a",
			"6b",
			"6c",
			"6d",
			"6e",
			"6f",
			"70",
			"71",
			"72",
			"73",
			"74",
			"75",
			"76",
			"77",
			"78",
			"79",
			"7a",
			"7b",
			"7c",
			"7d",
			"7e",
			"7f",
			"80",
			"81",
			"82",
			"83",
			"84",
			"85",
			"86",
			"87",
			"88",
			"89",
			"8a",
			"8b",
			"8c",
			"8d",
			"8e",
			"8f",
			"90",
			"91",
			"92",
			"93",
			"94",
			"95",
			"96",
			"97",
			"98",
			"99",
			"9a",
			"9b",
			"9c",
			"9d",
			"9e",
			"9f",
			"a0",
			"a1",
			"a2",
			"a3",
			"a4",
			"a5",
			"a6",
			"a7",
			"a8",
			"a9",
			"aa",
			"ab",
			"ac",
			"ad",
			"ae",
			"af",
			"b0",
			"b1",
			"b2",
			"b3",
			"b4",
			"b5",
			"b6",
			"b7",
			"b8",
			"b9",
			"ba",
			"bb",
			"bc",
			"bd",
			"be",
			"bf",
			"c0",
			"c1",
			"c2",
			"c3",
			"c4",
			"c5",
			"c6",
			"c7",
			"c8",
			"c9",
			"ca",
			"cb",
			"cc",
			"cd",
			"ce",
			"cf",
			"d0",
			"d1",
			"d2",
			"d3",
			"d4",
			"d5",
			"d6",
			"d7",
			"d8",
			"d9",
			"da",
			"db",
			"dc",
			"dd",
			"de",
			"df",
			"e0",
			"e1",
			"e2",
			"e3",
			"e4",
			"e5",
			"e6",
			"e7",
			"e8",
			"e9",
			"ea",
			"eb",
			"ec",
			"ed",
			"ee",
			"ef",
			"f0",
			"f1",
			"f2",
			"f3",
			"f4",
			"f5",
			"f6",
			"f7",
			"f8",
			"f9",
			"fa",
			"fb",
			"fc",
			"fd",
			"fe",
			"ff"
		];
		const d0 = Math.random() * 4294967295 | 0;
		const d1 = Math.random() * 4294967295 | 0;
		const d2 = Math.random() * 4294967295 | 0;
		const d3 = Math.random() * 4294967295 | 0;
		return (_lut[d0 & 255] + _lut[d0 >> 8 & 255] + _lut[d0 >> 16 & 255] + _lut[d0 >> 24 & 255] + "-" + _lut[d1 & 255] + _lut[d1 >> 8 & 255] + "-" + _lut[d1 >> 16 & 15 | 64] + _lut[d1 >> 24 & 255] + "-" + _lut[d2 & 63 | 128] + _lut[d2 >> 8 & 255] + "-" + _lut[d2 >> 16 & 255] + _lut[d2 >> 24 & 255] + _lut[d3 & 255] + _lut[d3 >> 8 & 255] + _lut[d3 >> 16 & 255] + _lut[d3 >> 24 & 255]).toLowerCase();
	},
	hexToRbg: function(hex) {
		hex = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(m, r, g, b) {
			return r + r + g + g + b + b;
		});
		var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
		return result ? {
			r: parseInt(result[1], 16),
			g: parseInt(result[2], 16),
			b: parseInt(result[3], 16)
		} : null;
	}
};
//#endregion
//#region node_modules/.pnpm/sp-supermarquee@3.1.2/node_modules/sp-supermarquee/src/core/Configuration.js
function Configuration(cd = {}) {
	this._gappedScrollingEnabled = false;
	this.easingValue = .025;
	this._currentSpeed = 0;
	this.setSpeed = function(speed) {
		if (this.type === Configuration.TYPE_HORIZONTAL) if (-1 < Object.keys(Configuration.SPEED_HORIZONTAL).indexOf(speed)) this.speed = +Configuration.SPEED_HORIZONTAL[speed];
		else if (+speed > 0) this.speed = +speed;
		else this.speed = +Configuration.SPEED_HORIZONTAL[Configuration.DEFAULT.speed];
		else if (-1 < Object.keys(Configuration.SPEED_VERTICAL).indexOf(speed)) this.speed = +Configuration.SPEED_VERTICAL[speed];
		else if (+speed > 0) this.speed = +speed;
		else this.speed = +Configuration.SPEED_VERTICAL[Configuration.DEFAULT.speed];
	};
	this.hasLicense = function() {
		return this.license !== null && this.license !== void 0 && this.license.length > 6;
	};
	this.getSpeedNoEasing = function() {
		return this.speed;
	}.bind(this);
	this.getSpeedWithEasing = function() {
		if (1 > this.easingValue) this._currentSpeed = (1 - this.easingValue) * this._currentSpeed + this.easingValue * this.speed;
		return this._currentSpeed;
	}.bind(this);
	this.getSpeed = this.getSpeedNoEasing;
	this.setContent = function(content) {
		if (content && content.length > 0) this.content = content;
		else this.content = "SuperMarquee by SuperPlug.in is Super !!!";
		this.content = this.content.replaceAll("> ", ">&nbsp;");
		this.content = this.content.replaceAll(" <", "&nbsp;<");
		if (Configuration.MODE_PINGPONG === this.mode && Configuration.TYPE_HORIZONTAL === this.type) this.content = this.spacer + this.content;
		this.content += this.spacer;
	};
	this.setPerspective = function(perspectiveSettings = null) {
		const props = Object.keys(Configuration.PERSPECTIVE_DEFAULT);
		let userSettings = {};
		if (perspectiveSettings) try {
			userSettings = JSON.parse(perspectiveSettings);
		} catch (e) {
			userSettings = {};
		}
		for (let pi = 0; pi < props.length; pi++) if (userSettings.hasOwnProperty(props[pi])) this.perspective[props[pi]] = userSettings[props[pi]];
		else this.perspective[props[pi]] = Configuration.PERSPECTIVE_DEFAULT[props[pi]];
	};
	this.setFader = function(faderSettings = null) {
		const props = Object.keys(this.fader);
		let fs = null;
		if (typeof faderSettings === "string" || faderSettings instanceof String) try {
			faderSettings = JSON.parse(faderSettings);
		} catch (e) {
			faderSettings = null;
		}
		if (typeof faderSettings === "object" && !Array.isArray(faderSettings) && faderSettings !== null) fs = faderSettings;
		if (fs === null) return false;
		for (let pi = 0; pi < props.length; pi++) if (fs.hasOwnProperty(props[pi])) {
			if (fs[props[pi]].hasOwnProperty("size")) this.fader[props[pi]].size = parseFloat(fs[props[pi]].size);
			if (fs[props[pi]].hasOwnProperty("colorFrom")) this.fader[props[pi]].colorFrom = fs[props[pi]].colorFrom;
			if (fs[props[pi]].hasOwnProperty("colorTo")) this.fader[props[pi]].colorTo = fs[props[pi]].colorTo;
		}
	};
	this.setPosition = function(position) {
		if (-1 < Configuration.POSITIONS.indexOf(position)) this.position = position;
		else this.position = Configuration.DEFAULT.position;
	};
	this.setPauseOnHover = function(pauseonhover) {
		if (pauseonhover && ("true" === pauseonhover || "1" === pauseonhover || true === pauseonhover)) this.pauseonhover = true;
		else this.pauseonhover = false;
	};
	let system = cd.hasOwnProperty("system") ? cd.system : null;
	if (-1 < Configuration.SYSTEMS.indexOf(system)) this.system = system;
	else this.system = Configuration.DEFAULT.system;
	let license = cd.hasOwnProperty("license") ? cd.license : null;
	this.license = null;
	if (license && license.length >= 4) this.license = cd.license;
	let type = cd.hasOwnProperty("type") ? cd.type : null;
	if (-1 < Configuration.TYPES.indexOf(type)) this.type = type;
	else this.type = Configuration.DEFAULT.type;
	this.spacer = cd.hasOwnProperty("spacer") ? cd.spacer : null;
	if (this.type === Configuration.TYPE_HORIZONTAL) if (!this.spacer) this.spacer = "&nbsp;";
	else this.spacer = Util.forceNbspInHtml(this.spacer);
	else if (!this.spacer) this.spacer = "<br />";
	let direction = cd.hasOwnProperty("direction") ? cd.direction : null;
	if (-1 < Configuration.DIRECTIONS.indexOf(direction)) this.direction = direction;
	else this.direction = Configuration.DEFAULT.direction;
	let mode = cd.hasOwnProperty("mode") ? cd.mode : null;
	if (-1 < Configuration.MODES.indexOf(mode)) this.mode = mode;
	else this.mode = Configuration.MODE_CONTINOUS;
	this.pingPongDelay = cd.hasOwnProperty("pingpongdelay") ? +cd.pingpongdelay : Configuration.PINGPONG_DELAY_DEFAULT;
	let position = cd.hasOwnProperty("position") ? cd.position : null;
	this.setPosition(position);
	this.perspective = {};
	this.setPerspective(cd.hasOwnProperty("perspective") ? cd.perspective : null);
	let speed = cd.hasOwnProperty("speed") ? cd.speed : null;
	this.setSpeed(speed);
	this._currentSpeed = this.speed;
	this.setContent(cd.hasOwnProperty("content") ? cd.content : null);
	let pauseonhover = cd.hasOwnProperty("pauseonhover") ? cd.pauseonhover : null;
	this.setPauseOnHover(pauseonhover);
	let autostart = cd.hasOwnProperty("autostart") ? cd.autostart : null;
	if (autostart && ("false" === autostart || "0" === autostart)) this.autostart = false;
	else this.autostart = true;
	let easing = cd.hasOwnProperty("easing") ? cd.easing : null;
	if (easing && ("true" === easing || "1" === easing || true === easing)) {
		this.easing = true;
		this.getSpeed = this.getSpeedWithEasing;
	} else {
		this.easing = false;
		this.getSpeed = this.getSpeedNoEasing;
	}
	this.rssFeedUrl = cd.hasOwnProperty("rssFeedUrl") ? cd.rssFeedUrl : null;
	this.rssFeedTemplate = cd.hasOwnProperty("rssFeedTemplate") ? Util.forceNbspInHtml(cd.rssFeedTemplate) : this.rssFeedTemplate;
	this.fader = JSON.parse(JSON.stringify(Configuration.FADER_DEFAULT));
	this.setFader(cd.hasOwnProperty("fader") ? cd.fader : null);
	this.cssClass = null;
	if (cd.hasOwnProperty("cssClass") && (typeof cd.cssClass === "string" || cd.cssClass instanceof String) && cd.cssClass.length > 0) this.cssClass = cd.cssClass;
}
Configuration.SYSTEM_WEBCOMPONENT = "webcomponent";
Configuration.SYSTEM_JQUERY = "jquery";
Configuration.SYSTEM_VANILLA = "vanilla";
Configuration.SYSTEMS = [
	Configuration.SYSTEM_WEBCOMPONENT,
	Configuration.SYSTEM_JQUERY,
	Configuration.SYSTEM_VANILLA
];
Configuration.TYPE_HORIZONTAL = "horizontal";
Configuration.TYPE_VERTICAL = "vertical";
Configuration.TYPES = [Configuration.TYPE_HORIZONTAL, Configuration.TYPE_VERTICAL];
Configuration.DIRECTION_LTR = "ltr";
Configuration.DIRECTION_RTL = "rtl";
Configuration.DIRECTION_BTT = "btt";
Configuration.DIRECTION_TTB = "ttb";
Configuration.DIRECTIONS = [
	Configuration.DIRECTION_LTR,
	Configuration.DIRECTION_RTL,
	Configuration.DIRECTION_BTT,
	Configuration.DIRECTION_TTB
];
Configuration.POSITION_CUSTOM = "custom";
Configuration.POSITION_FIXEDTOP = "fixedTop";
Configuration.POSITION_FIXEDBOTTOM = "fixedBottom";
Configuration.POSITIONS = [
	Configuration.POSITION_CUSTOM,
	Configuration.POSITION_FIXEDTOP,
	Configuration.POSITION_FIXEDBOTTOM
];
Configuration.MODE_CONTINOUS = "continuous";
Configuration.MODE_GAPPED = "gapped";
Configuration.MODE_PINGPONG = "pingpong";
Configuration.MODES = [
	Configuration.MODE_CONTINOUS,
	Configuration.MODE_GAPPED,
	Configuration.MODE_PINGPONG
];
Configuration.SPEED_SUPERSLOW = "superslow";
Configuration.SPEED_SLOW = "slow";
Configuration.SPEED_MEDIUM = "medium";
Configuration.SPEED_FAST = "fast";
Configuration.SPEED_SUPERFAST = "superfast";
Configuration.SPEED_HORIZONTAL = {
	"superslow": .0125,
	"slow": .03,
	"medium": .05,
	"fast": .125,
	"superfast": .2
};
Configuration.SPEED_VERTICAL = {
	"superslow": .0125,
	"slow": .03,
	"medium": .05,
	"fast": .125,
	"superfast": .2
};
Configuration.PERSPECTIVE_DEFAULT = {
	"z": "none",
	"originX": 50,
	"originY": 50,
	"rotateX": 0,
	"rotateY": 0,
	"rotateZ": 0
};
Configuration.FADER_DEFAULT = {
	"left": {
		"size": 0,
		"colorFrom": "rgba( 255, 255, 255, 1 )",
		"colorTo": "rgba( 255, 255, 255, 0 )"
	},
	"right": {
		"size": 0,
		"colorFrom": "rgba( 255, 255, 255, 255 )",
		"colorTo": "rgba( 255, 255, 255, 0 )"
	},
	"top": {
		"size": 0,
		"colorFrom": "rgba( 255, 255, 255, 255 )",
		"colorTo": "rgba( 255, 255, 255, 0 )"
	},
	"bottom": {
		"size": 0,
		"colorFrom": "rgba( 255, 255, 255, 255 )",
		"colorTo": "rgba( 255, 255, 255, 0 )"
	}
};
Configuration.PINGPONG_DELAY_DEFAULT = 2e3;
Configuration.DEFAULT = {
	"license": null,
	"system": Configuration.SYSTEM_VANILLA,
	"type": Configuration.TYPE_HORIZONTAL,
	"speed": Configuration.SPEED_MEDIUM,
	"direction": Configuration.DIRECTION_LTR,
	"mode": Configuration.MODE_CONTINOUS,
	"position": Configuration.POSITION_CUSTOM,
	"perspective": Configuration.PERSPECTIVE_DEFAULT,
	"pauseonhover": false,
	"autostart": true,
	"easing": false,
	"content": "SuperMarquee By SuperPlug.in Is Super !!!",
	"rssFeedUrl": null,
	"rssFeedTemplate": "<a href=\"${link}\" target=\"_blank\">${title}</a>",
	"pingPongDelay": Configuration.PINGPONG_DELAY_DEFAULT,
	"spacer": null,
	"fader": Configuration.FADER_DEFAULT,
	"cssClass": null
};
//#endregion
//#region node_modules/.pnpm/sp-supermarquee@3.1.2/node_modules/sp-supermarquee/src/core/Event.js
function Event(i) {
	const inst = i;
	this.getInstance = function() {
		return inst;
	};
}
Event.prototype.triggerInit = function() {
	this.getInstance().getRootElement().dispatchEvent(new Event("init"));
};
Event.prototype.triggerStart = function() {
	this.getInstance().getRootElement().dispatchEvent(new Event("start"));
};
Event.prototype.triggerLoop = function() {
	this.getInstance().getRootElement().dispatchEvent(new Event("loop"));
};
Event.prototype.triggerPause = function() {
	this.getInstance().getRootElement().dispatchEvent(new Event("pause"));
};
Event.prototype.triggerResume = function() {
	this.getInstance().getRootElement().dispatchEvent(new Event("resume"));
};
//#endregion
//#region node_modules/.pnpm/sp-supermarquee@3.1.2/node_modules/sp-supermarquee/src/core/TickLogic.js
var TickLogic = {
	fnNoScroll: function(dt) {},
	fnHorizontalLtrPingPong: function(dt) {
		if (1 === this._pingPongCurrentDirection) {
			this._currentXPos += dt * this.config.getSpeed();
			if (this._currentXPos + this.dimensions.visibleWidth > this.dimensions.totalScrollItemWidth) {
				this._pingPongCurrentDirection = 0;
				this._pingPongNextDirection = -1;
			}
		} else if (-1 === this._pingPongCurrentDirection) {
			this._currentXPos -= dt * this.config.getSpeed();
			if (this._currentXPos <= 0) {
				this._pingPongCurrentDirection = 0;
				this._pingPongNextDirection = 1;
			}
		} else {
			this._pingPongPauseDelay -= dt;
			if (this._pingPongPauseDelay < 0) {
				this._pingPongCurrentDirection = this._pingPongNextDirection;
				this._pingPongPauseDelay = this.config.pingPongDelay;
			}
		}
		this.elems.innerContainer.style.transform = "translate3d(-" + this._currentXPos + "px,0,0)";
	},
	fnHorizontalRtlPingPong: function(dt) {
		if (1 === this._pingPongCurrentDirection) {
			this._currentXPos -= dt * this.config.getSpeed();
			if (this._currentXPos < 0) {
				this._currentXPos = 0;
				this._pingPongCurrentDirection = 0;
				TickLogic._pingPongNextDirection = -1;
			}
		} else if (-1 === this._pingPongCurrentDirection) {
			this._currentXPos += dt * this.config.getSpeed();
			if (this._currentXPos > this.dimensions.totalScrollItemWidth - this.dimensions.visibleWidth) {
				this._currentXPos = this.dimensions.totalScrollItemWidth - this.dimensions.visibleWidth;
				this._pingPongCurrentDirection = 0;
				this._pingPongNextDirection = 1;
			}
		} else {
			this._pingPongPauseDelay -= dt;
			if (this._pingPongPauseDelay < 0) {
				this._pingPongCurrentDirection = this._pingPongNextDirection;
				this._pingPongPauseDelay = this.config.pingPongDelay;
			}
		}
		this.elems.innerContainer.style.transform = "translate3d(-" + this._currentXPos + "px,0,0)";
	},
	fnHorizontalTtbPingPong: function(dt) {
		if (1 === this._pingPongCurrentDirection) {
			this._currentYPos -= dt * this.config.getSpeed();
			if (this._currentYPos < -(this.dimensions.totalScrollItemHeight - this.dimensions.visibleHeight)) {
				this._currentYPos = -(this.dimensions.totalScrollItemHeight - this.dimensions.visibleHeight);
				this._pingPongCurrentDirection = 0;
				this._pingPongNextDirection = -1;
			}
		} else if (-1 === this._pingPongCurrentDirection) {
			this._currentYPos += dt * this.config.getSpeed();
			if (this._currentYPos > 0) {
				this._currentYPos = 0;
				this._pingPongCurrentDirection = 0;
				this._pingPongNextDirection = 1;
			}
		} else {
			this._pingPongPauseDelay -= dt;
			if (this._pingPongPauseDelay < 0) {
				this._pingPongCurrentDirection = this._pingPongNextDirection;
				this._pingPongPauseDelay = this.config.pingPongDelay;
			}
		}
		this.elems.innerContainer.style.transform = "translate3d(0," + this._currentYPos + "px, 0)";
	},
	fnHorizontalBttPingPong: function(dt) {
		if (1 === this._pingPongCurrentDirection) {
			this._currentYPos += dt * this.config.getSpeed();
			if (this._currentYPos > 0) {
				this._currentYPos = 0;
				this._pingPongCurrentDirection = 0;
				this._pingPongNextDirection = -1;
			}
		} else if (-1 === this._pingPongCurrentDirection) {
			this._currentYPos -= dt * this.config.getSpeed();
			if (this._currentYPos < -(this.dimensions.totalScrollItemHeight - this.dimensions.visibleHeight)) {
				this._currentYPos = -(this.dimensions.totalScrollItemHeight - this.dimensions.visibleHeight);
				this._pingPongCurrentDirection = 0;
				this._pingPongNextDirection = 1;
			}
		} else {
			this._pingPongPauseDelay -= dt;
			if (this._pingPongPauseDelay < 0) {
				this._pingPongCurrentDirection = this._pingPongNextDirection;
				this._pingPongPauseDelay = this.config.pingPongDelay;
			}
		}
		this.elems.innerContainer.style.transform = "translate3d(0," + this._currentYPos + "px, 0)";
	},
	fnHorizontalLtr: function(dt) {
		this._currentXPos += dt * this.config.getSpeed();
		if (this._currentXPos > this.dimensions.totalScrollItemWidth) this._currentXPos = this.dimensions.totalScrollItemWidth - this._currentXPos;
		this.elems.innerContainer.style.transform = "translate3d(-" + this._currentXPos + "px,0,0)";
	},
	fnHorizontalRtl: function(dt) {
		this._currentXPos -= dt * this.config.getSpeed();
		if (this._currentXPos < this.dimensions.totalScrollItemWidth) this._currentXPos = this.dimensions.totalScrollItemWidth + this._currentXPos;
		this.elems.innerContainer.style.transform = "translate3d(-" + (this._currentXPos - this.dimensions.totalScrollItemWidth) + "px,0,0)";
	},
	fnVerticalBtt: function(dt) {
		this._currentYPos += dt * this.config.getSpeed();
		if (this._currentYPos > this.dimensions.totalScrollItemHeight) this._currentYPos = this.dimensions.totalScrollItemHeight - this._currentYPos;
		this.elems.innerContainer.style.transform = "translate3d(0, -" + this._currentYPos + "px,0)";
	},
	fnVerticalTtb: function(dt) {
		this._currentYPos -= dt * this.config.getSpeed();
		if (this._currentYPos < this.dimensions.totalScrollItemHeight) this._currentYPos = this.dimensions.totalScrollItemHeight + this._currentYPos;
		this.elems.innerContainer.style.transform = "translate3d(0, -" + (this._currentYPos - this.dimensions.totalScrollItemHeight) + "px,0)";
	}
};
//#endregion
//#region node_modules/.pnpm/sp-supermarquee@3.1.2/node_modules/sp-supermarquee/src/core/RssFeedReader.js
var RssFeedReader = {
	getFeed: function getFeed(url) {
		let xmlHttp = new XMLHttpRequest();
		try {
			xmlHttp.open("GET", url, false);
			xmlHttp.send(null);
		} catch (e) {
			console.error(e);
			xmlHttp = null;
		}
		return xmlHttp ? xmlHttp.responseXML : null;
	},
	getFeedItemData: function(url) {
		const feedXml = this.getFeed(url), items = feedXml ? feedXml.getElementsByTagName("item") : null, feedData = [];
		if (items && items.length > 0) for (let i = 0; i < items.length; i++) feedData.push({
			"title": 0 < items[i].getElementsByTagName("title").length ? items[i].getElementsByTagName("title")[0].innerHTML : null,
			"link": 0 < items[i].getElementsByTagName("link").length ? items[i].getElementsByTagName("link")[0].innerHTML : null,
			"pubDate": 0 < items[i].getElementsByTagName("pubDate").length ? new Date(items[i].getElementsByTagName("pubDate")[0].innerHTML) : null,
			"description": 0 < items[i].getElementsByTagName("description").length && items[i].getElementsByTagName("description")[0].firstChild ? items[i].getElementsByTagName("description")[0].firstChild.wholeText.trim() : null,
			"content": 0 < items[i].getElementsByTagName("content").length ? items[i].getElementsByTagName("content")[0].innerHTML : null
		});
		return feedData;
	},
	getScrollContentOfFeed: function(url, spacer = "&nbsp;") {
		const feedXml = this.getFeed(url), items = feedXml ? feedXml.getElementsByTagName("item") : null;
		let feedContent = "";
		if (items && items.length > 0) for (let i = 0; i < items.length; i++) {
			feedContent += "<a href=\"" + items[i].getElementsByTagName("link")[0].innerHTML + "\" target=\"_blank\">";
			feedContent += items[i].getElementsByTagName("title")[0].innerHTML + "</a>";
			feedContent += spacer;
		}
		return feedContent;
	}
};
//#endregion
//#region node_modules/.pnpm/sp-supermarquee@3.1.2/node_modules/sp-supermarquee/src/core/Core.js
var hasLicenseTextBeenShown = false;
function Core(root, config) {
	const self = this, events = new Event(this);
	let fnTick = TickLogic.fnNoScroll.bind(this);
	this.elems = {
		rootElement: root,
		shadowRoot: null,
		container: null,
		outerWrapper: null,
		innerContainer: null,
		scrollItem: null,
		scrollItemClone: null
	};
	this.config = config;
	this.dimensions = {};
	this._uuid = Util.generateUUID();
	this._time = Date.now();
	this._rafId = null;
	this._shouldPlay = false;
	this._wasPlaying = false;
	this._isInView = true;
	this._previousDimensions = {
		width: this.elems.rootElement.offsetWidth,
		height: this.elems.rootElement.offsetHeight
	};
	const listenerWindowResize = () => {
		if (this.elems.rootElement.offsetWidth === this._previousDimensions.width && this.elems.rootElement.offsetHeight === this._previousDimensions.height) return false;
		else this._previousDimensions = {
			width: this.elems.rootElement.offsetWidth,
			height: this.elems.rootElement.offsetHeight
		};
		let wasRunning = false;
		if (this._rafId) {
			wasRunning = true;
			window.cancelAnimationFrame(this._rafId);
			this._rafId = null;
		}
		this.init();
		if (wasRunning) this.tick();
	}, listenerDocumentVisibilityChange = () => {
		if (true === document.hidden) this.onOutOfView();
		else this.onIntoView();
	}, listenerElemsContainerMouseEnter = () => {
		if (true === this.config.pauseonhover) this.pause();
	}, listenerElemsContainerMouseLeave = () => {
		if (true === this.config.pauseonhover) this.play();
	};
	let observer = null;
	document.addEventListener("DOMContentLoaded", () => {
		if (!observer) {
			observer = new IntersectionObserver((entries, observer) => {
				let entry = entries.length ? entries[0] : null;
				if (entry) if (true === entry.isIntersecting) this.onIntoView();
				else this.onOutOfView();
			}, { rootMargin: "0px 0px 20px 0px" });
			observer.observe(self.elems.container);
		}
	});
	setup();
	this.init = function() {
		if (this.config.cssClass && this.config.cssClass.length > 0) this.elems.rootElement.classList.add(this.config.cssClass);
		this.elems.container.style.visibility = "hidden";
		let prevPosition = this.elems.rootElement.style.position;
		this.elems.rootElement.style.position = "initial";
		this.elems.scrollItem.innerHTML = "";
		this.elems.scrollItemClone.innerHTML = "";
		let scrollContent = this.config.content;
		if (this.config.rssFeedUrl) {
			const feedItemData = RssFeedReader.getFeedItemData(this.config.rssFeedUrl);
			if (feedItemData && feedItemData.length > 0) {
				let title, link, pubDate, description, content;
				for (let fi = 0; fi < feedItemData.length; fi++) {
					title = feedItemData[fi].hasOwnProperty("title") && feedItemData[fi].title ? feedItemData[fi].title : "";
					link = feedItemData[fi].hasOwnProperty("link") && feedItemData[fi]["link"] ? feedItemData[fi]["link"] : "#";
					pubDate = feedItemData[fi].hasOwnProperty("pubDate") && feedItemData[fi].pubDate ? feedItemData[fi].pubDate : /* @__PURE__ */ new Date();
					description = feedItemData[fi].hasOwnProperty("description") && feedItemData[fi].description ? feedItemData[fi].description : "";
					content = feedItemData[fi].hasOwnProperty("content") && feedItemData[fi].content ? feedItemData[fi].content : "";
					scrollContent += eval("`" + this.config.rssFeedTemplate + "`");
					scrollContent += this.config.spacer;
				}
			}
		}
		if (Configuration.TYPE_HORIZONTAL === this.config.type) {
			let maxWidth;
			switch (this.config.mode) {
				case Configuration.MODE_PINGPONG:
					this.elems.scrollItem.innerHTML += scrollContent;
					this.elems.scrollItemClone.innerHTML = "";
					maxWidth = prevPosition === "fixed" ? window.innerWidth : this.elems.container.clientWidth;
					this.config._gappedScrollingEnabled = maxWidth < this.elems.scrollItem.clientWidth;
					break;
				case Configuration.MODE_GAPPED:
					this.elems.scrollItem.innerHTML += scrollContent;
					this.elems.scrollItem.style.paddingLeft = this.elems.container.clientWidth + "px";
					this.elems.scrollItemClone.innerHTML = "";
					break;
				default:
				case Configuration.MODE_CONTINOUS:
					maxWidth = prevPosition === "fixed" ? window.innerWidth : this.elems.container.clientWidth;
					while (maxWidth > this.elems.scrollItem.clientWidth) this.elems.scrollItem.innerHTML += scrollContent;
					this.elems.scrollItemClone.innerHTML = this.elems.scrollItem.innerHTML;
					break;
			}
		} else {
			if (0 <= this.elems.scrollItem.getBoundingClientRect().height) this.elems.scrollItem.innerHTML = "&nbsp;";
			let maxHeight = prevPosition === "fixed" ? window.innerHeight : this.elems.container.clientHeight;
			this.elems.outerWrapper.style.maxHeight = maxHeight + "px";
			this.elems.scrollItem.innerHTML = "";
			scrollContent = scrollContent.replace(/(?:\r\n|\r|\n)/g, "<br />");
			switch (this.config.mode) {
				case Configuration.MODE_PINGPONG:
					this.elems.scrollItem.innerHTML += scrollContent;
					this.elems.scrollItemClone.innerHTML = "";
					maxHeight = prevPosition === "fixed" ? window.innerHeight : this.elems.container.clientHeight;
					this.config._gappedScrollingEnabled = maxHeight < this.elems.scrollItem.clientHeight;
					break;
				case Configuration.MODE_GAPPED:
					this.elems.scrollItem.innerHTML += scrollContent;
					this.elems.scrollItem.style.paddingTop = this.elems.container.clientHeight + "px";
					this.elems.scrollItemClone.innerHTML = "";
					break;
				default:
				case Configuration.MODE_CONTINOUS:
					maxHeight = prevPosition === "fixed" ? window.innerHeight : this.elems.container.clientHeight;
					while (maxHeight > this.elems.scrollItem.clientHeight) this.elems.scrollItem.innerHTML += scrollContent;
					this.elems.scrollItemClone.innerHTML = this.elems.scrollItem.innerHTML;
					break;
			}
		}
		this.updatePerspective();
		setTimeout(() => {
			this.updateDimensions();
			this.updateTickLogic();
			this.elems.container.style.visibility = "visible";
			this.onIntoView();
		}, 100);
		this._currentXPos = 0;
		this._currentYPos = 0;
		this._pingPongCurrentDirection = 0;
		this._pingPongNextDirection = -1;
		this._pingPongPauseDelay = self.config.pingPongDelay;
		this._time = Date.now();
		this.config.setPosition(this.config.position);
		switch (this.config.position) {
			case Configuration.POSITION_FIXEDTOP:
				this.elems.rootElement.style.position = "fixed";
				this.elems.rootElement.style.removeProperty("left");
				this.elems.rootElement.style.removeProperty("top");
				this.elems.rootElement.style.removeProperty("bottom");
				this.elems.rootElement.style.width = "100%";
				this.elems.rootElement.style.top = 0;
				this.elems.rootElement.style.bottom = "initial";
				this.elems.rootElement.style.left = 0;
				break;
			case Configuration.POSITION_FIXEDBOTTOM:
				this.elems.rootElement.style.position = "fixed";
				this.elems.rootElement.style.removeProperty("left");
				this.elems.rootElement.style.removeProperty("bottom");
				this.elems.rootElement.style.width = "100%";
				this.elems.rootElement.style.top = "initial";
				this.elems.rootElement.style.bottom = 0;
				this.elems.rootElement.style.left = 0;
				break;
			default:
			case Configuration.POSITION_CUSTOM:
				this.elems.rootElement.style.position = prevPosition;
				this.elems.rootElement.style.removeProperty("position");
				this.elems.rootElement.style.removeProperty("left");
				this.elems.rootElement.style.removeProperty("top");
				this.elems.rootElement.style.removeProperty("bottom");
				break;
		}
		this.setFader(this.config.fader);
		if (false === this.config.hasLicense() && window.console && false === hasLicenseTextBeenShown) {
			hasLicenseTextBeenShown = true;
			console.log("%c»SuperMarquee« by SuperPlug.in. Unlicensed version for non commercial use only.", "font-family: monospace sans-serif; background-color: #8089ff; color: white;font-weight: bold;");
		}
	}.bind(this);
	this.updatePerspective = function() {
		this.elems.perspective.style.perspective = this.config.perspective.z + "px";
		this.elems.perspective.style.perspectiveOrigin = this.config.perspective.originX + "% " + this.config.perspective.originY + "%";
		this.elems.outerWrapper.style.transform = "rotateX(" + this.config.perspective.rotateX + "deg) rotateY(" + this.config.perspective.rotateY + "deg) rotateZ(" + this.config.perspective.rotateZ + "deg)";
	}.bind(this);
	this.getInstanceId = function() {
		return this._uuid;
	};
	this.updateTickLogic = function() {
		if (Configuration.MODE_PINGPONG === self.config.mode) if (false === self.config._gappedScrollingEnabled) fnTick = TickLogic.fnNoScroll.bind(self);
		else if (Configuration.TYPE_HORIZONTAL === self.config.type) switch (self.config.direction) {
			case Configuration.DIRECTION_RTL:
				this._currentXPos = this.dimensions.totalScrollItemWidth - this.dimensions.visibleWidth;
				this._pingPongCurrentDirection = 0;
				this._pingPongNextDirection = -1;
				this._pingPongPauseDelay = self.config.pingPongDelay;
				fnTick = TickLogic.fnHorizontalRtlPingPong.bind(self);
				break;
			default:
			case Configuration.DIRECTION_LTR:
				this._currentXPos = 0;
				this._pingPongCurrentDirection = 0;
				this._pingPongNextDirection = 1;
				this._pingPongPauseDelay = self.config.pingPongDelay;
				fnTick = TickLogic.fnHorizontalLtrPingPong.bind(self);
				break;
		}
		else switch (self.config.direction) {
			case Configuration.DIRECTION_TTB:
				this._currentYPos = -(this.dimensions.totalScrollItemHeight - this.dimensions.visibleHeight);
				this._pingPongCurrentDirection = 0;
				this._pingPongNextDirection = -1;
				this._pingPongPauseDelay = self.config.pingPongDelay;
				fnTick = TickLogic.fnHorizontalTtbPingPong.bind(self);
				break;
			case Configuration.DIRECTION_BTT:
				this._currentYPos = 0;
				this._pingPongCurrentDirection = 0;
				this._pingPongNextDirection = -1;
				this._pingPongPauseDelay = self.config.pingPongDelay;
				fnTick = TickLogic.fnHorizontalBttPingPong.bind(self);
				break;
		}
		else if (Configuration.TYPE_HORIZONTAL === self.config.type) switch (self.config.direction) {
			case Configuration.DIRECTION_RTL:
				fnTick = TickLogic.fnHorizontalRtl.bind(self);
				break;
			default:
			case Configuration.DIRECTION_LTR:
				fnTick = TickLogic.fnHorizontalLtr.bind(self);
				break;
		}
		else switch (self.config.direction) {
			case Configuration.DIRECTION_TTB:
				fnTick = TickLogic.fnVerticalTtb.bind(self);
				break;
			default:
			case Configuration.DIRECTION_BTT:
				fnTick = TickLogic.fnVerticalBtt.bind(self);
				break;
		}
	}.bind(this);
	this.updateDimensions = function() {
		this.dimensions.visibleWidth = this.elems.container.clientWidth;
		this.dimensions.visibleHeight = this.elems.container.clientHeight;
		this.dimensions.totalScrollItemWidth = this.elems.scrollItem.offsetWidth;
		this.dimensions.totalScrollItemHeight = this.elems.scrollItem.offsetHeight;
	}.bind(this);
	this.tick = function() {
		const currentTime = Date.now();
		const deltaTime = currentTime - this._time;
		this._time = currentTime;
		if (this._shouldPlay) fnTick(deltaTime);
		this._rafId = window.requestAnimationFrame(this.tick);
	}.bind(this);
	this.getRootElement = function() {
		return this.elems.rootElement;
	}.bind(this);
	this.getEvents = function() {
		return events;
	};
	this.destroy = function() {
		if (this._rafId) {
			window.cancelAnimationFrame(this._rafId);
			this._rafId = null;
		}
		window.removeEventListener("resize", listenerWindowResize);
		document.removeEventListener("visibilitychange", listenerDocumentVisibilityChange);
		this.elems.container.removeEventListener("mouseenter", listenerElemsContainerMouseEnter);
		this.elems.container.removeEventListener("mouseleave", listenerElemsContainerMouseLeave);
		if (observer) observer.unobserve(this.elems.container);
		this.elems.rootElement.innerHTML = "";
	};
	this.getScrollContent = function() {
		return this.config.content;
	};
	function setup() {
		switch (self.config.system) {
			case Configuration.SYSTEM_JQUERY:
			case Configuration.SYSTEM_VANILLA:
			case Configuration.SYSTEM_WEBCOMPONENT:
				self.elems.shadowRoot = self.elems.rootElement;
				if (self.config.type === Configuration.TYPE_VERTICAL) {
					const templ = getVertical({ instanceId: self._uuid });
					self.elems.shadowRoot.appendChild(templ.content.cloneNode(true));
				} else {
					const templ = getHorizontal({ instanceId: self._uuid });
					self.elems.shadowRoot.appendChild(templ.content.cloneNode(true));
				}
				self.elems.container = self.elems.shadowRoot.querySelector("[data-id=\"supermarquee-container\"]");
				self.elems.perspective = self.elems.shadowRoot.querySelector("[data-id=\"supermarquee-perspective\"]:first-child");
				self.elems.outerWrapper = self.elems.shadowRoot.querySelector("[data-id=\"supermarquee-outer-wrapper\"]:first-child");
				self.elems.innerContainer = self.elems.shadowRoot.querySelector("[data-id=\"supermarquee-inner-container\"]:first-child");
				break;
		}
		self.elems.scrollItem = self.elems.innerContainer.querySelector("[data-id=\"supermarquee-item\"]:first-child");
		self.elems.scrollItemClone = self.elems.innerContainer.querySelector("[data-id=\"supermarquee-item-clone\"]");
		window.addEventListener("resize", listenerWindowResize);
		document.addEventListener("visibilitychange", listenerDocumentVisibilityChange);
		self.elems.container.addEventListener("mouseenter", listenerElemsContainerMouseEnter);
		self.elems.container.addEventListener("mouseleave", listenerElemsContainerMouseLeave);
	}
}
Core.prototype.VERSION = "3.1";
Core.prototype.play = function() {
	this._shouldPlay = true;
	if (false === this._isInView) return;
	if (!this._rafId) {
		this._time = Date.now();
		this.tick();
		this._wasPlaying = true;
	}
};
Core.prototype.pause = function() {
	this._shouldPlay = false;
	if (this._rafId) {
		window.cancelAnimationFrame(this._rafId);
		this._rafId = null;
		this._wasPlaying = true;
	} else this._wasPlaying = false;
};
Core.prototype.setPingPongDelay = function(pingPongDelay) {
	let ppd = +pingPongDelay;
	if (ppd <= 0) ppd = Configuration.PINGPONG_DELAY_DEFAULT;
	this.config.pingPongDelay = ppd;
};
Core.prototype.setScrollContent = function(content) {
	this.config.setContent(content);
	this.init();
};
Core.prototype.setScrollSpeed = function(speed) {
	this.config.setSpeed(speed);
};
Core.prototype.setPosition = function(position) {
	this.config.setPosition(position);
	this.init();
};
Core.prototype.setPauseOnHover = function(pauseonhover) {
	this.config.setPauseOnHover(pauseonhover);
};
Core.prototype.setPerspective = function(perspective) {
	this.config.setPerspective(perspective);
	this.updatePerspective();
};
Core.prototype.setFader = function(fader) {
	this.config.setFader(fader);
	this.updateFader();
};
Core.prototype.updateFader = function() {
	const gradientDirections = {
		"left": "to right",
		"right": "to left",
		"top": "180deg",
		"bottom": "180deg"
	};
	const props = this.config.type === Configuration.TYPE_HORIZONTAL ? ["left", "right"] : ["top", "bottom"];
	const fd = this.config.fader;
	if (this.config.type === Configuration.TYPE_HORIZONTAL) {
		this.elems.outerWrapper.classList.remove(`fader-top-${this.getInstanceId()}`);
		this.elems.outerWrapper.classList.remove(`fader-bottom-${this.getInstanceId()}`);
	} else {
		this.elems.outerWrapper.classList.remove(`fader-left-${this.getInstanceId()}`);
		this.elems.outerWrapper.classList.remove(`fader-right-${this.getInstanceId()}`);
	}
	for (let pi = 0; pi < props.length; pi++) {
		const prop = props[pi];
		const propUp = String(prop).charAt(0).toUpperCase() + String(prop).slice(1);
		if (fd[prop].size <= 0) this.elems.outerWrapper.classList.remove("fader-" + prop + "-" + this.getInstanceId());
		else if (this.config.mode === Configuration.MODE_PINGPONG && false === this.config._gappedScrollingEnabled) {} else {
			this.elems.outerWrapper.classList.add("fader-" + prop + "-" + this.getInstanceId());
			this.elems.outerWrapper.style.setProperty(`--fader${propUp}`, `${fd[prop].size}%`);
			this.elems.outerWrapper.style.setProperty(`--fader${propUp}Gradient`, `linear-gradient( ${gradientDirections[prop]}, ${fd[prop].colorFrom}, ${fd[prop].colorTo})`);
		}
	}
};
Core.prototype.onIntoView = function() {
	this._isInView = true;
	this.play();
};
Core.prototype.onOutOfView = function() {
	this._isInView = false;
	this.pause();
};
Core.prototype.destroy = function() {};
Core.prototype.Log = function(message, level = "info") {
	console[level](message);
};
//#endregion
//#region node_modules/.pnpm/sp-supermarquee@3.1.2/node_modules/sp-supermarquee/src/core/SuperMarquee.js
function SuperMarquee(rootElement, cfg = {}) {
	if (!rootElement || false === rootElement instanceof HTMLElement) throw new Error("Missing/invalid rootElement: ", rootElement);
	const configData = JSON.parse(JSON.stringify(Configuration.DEFAULT));
	let config;
	for (let k in configData) if (cfg.hasOwnProperty(k)) configData[k] = cfg[k];
	else if (rootElement.hasAttribute("data-" + k.toLowerCase())) configData[k] = rootElement.getAttribute("data-" + k.toLowerCase());
	configData.system = Configuration.SYSTEM_VANILLA;
	config = new Configuration(configData);
	this._core = new Core(rootElement, config);
	this._core.init();
	setTimeout(() => {
		if (this._core.config.autostart) this._core.tick();
	}, 150);
	return this;
}
SuperMarquee.getDefaultConfiguration = function() {
	return JSON.parse(JSON.stringify(Configuration.DEFAULT));
};
SuperMarquee.prototype.play = function() {
	this._core.play();
};
SuperMarquee.prototype.pause = function() {
	this._core.pause();
};
SuperMarquee.prototype.setScrollContent = function(content) {
	this._core.setScrollContent(content);
};
SuperMarquee.prototype.setScrollSpeed = function(speed) {
	this._core.setScrollSpeed(speed);
};
SuperMarquee.prototype.getScrollSpeed = function() {
	return +this._core.config.speed;
};
SuperMarquee.prototype.setPosition = function(position) {
	this._core.setPosition(position);
};
SuperMarquee.prototype.setPauseOnHover = function(pauseonhover) {
	this._core.setPauseOnHover(pauseonhover);
};
SuperMarquee.prototype.setPerspective = function(perspective) {
	this._core.setPerspective(perspective);
};
SuperMarquee.prototype.setPingPongDelay = function(ppd) {
	this._core.setPingPongDelay(ppd);
};
SuperMarquee.prototype.destroy = function() {
	this._core.destroy();
};
//#endregion
//#region frontend/islands/scrolling-marquee.js
var DOG_SEPARATOR = `<div class="-mt-[10px] md:-mt-[8px] px-gutter-xl -mr-gutter-sm flex items-center justify-center"><svg width="41.4" overflow="visible" preserveAspectRatio="xMidYMid meet" height="43.2" viewBox="0 0 46 48" aria-hidden="true" focusable="false" fill="currentColor"><path d="M22.9998 0.000267959C30.7882 -0.0310843 38.6238 2.68884 42.3415 8.14382C45.5054 12.7867 45.91 18.7964 45.9939 24.2473C46.0759 29.5822 45.4227 35.3354 42.3415 39.8567C38.6238 45.3114 30.7882 48.0309 22.9998 47.9993C15.2114 48.0309 7.37662 45.3116 3.65893 39.8567C0.577685 35.3353 -0.0753903 29.5823 0.00658874 24.2473C0.090443 18.7965 0.494817 12.7867 3.65893 8.14382C7.37631 2.68892 15.2117 -0.0310065 22.9998 0.000267959ZM23.0769 1.53933C15.7839 1.51004 8.44689 4.05453 4.96557 9.15945C2.0023 13.5047 1.6232 19.1302 1.54467 24.2317C1.46792 29.2247 2.07907 34.6096 4.9646 38.8411C8.4461 43.9462 15.7835 46.4908 23.0769 46.4612C30.3703 46.4908 37.7076 43.9459 41.1892 38.8411C44.0747 34.6096 44.6859 29.2247 44.6091 24.2317C44.5306 19.1302 44.1522 13.5047 41.1892 9.15945C37.7076 4.05449 30.3702 1.50999 23.0769 1.53933Z" /><path d="M8.64295 32.5904H8.50195C8.49128 32.5904 8.4806 32.5882 8.47102 32.5835C8.36726 32.5329 8.13948 32.5022 8.09294 32.2638C7.99493 31.7603 8.22243 31.2396 8.67689 30.9855C9.00159 30.804 9.28768 30.5924 9.51573 30.2948L10.2954 29.278C10.4786 29.0393 10.7058 28.8268 10.9861 28.713C10.9886 28.7121 10.9908 28.711 10.9933 28.7102C11.0672 28.6809 11.0456 28.5714 10.9659 28.5736C10.6382 28.5835 10.2576 28.627 9.93514 28.7485C9.38541 28.9561 8.9033 29.2443 8.40997 29.5608L6.71834 30.6471C6.3753 30.8673 6.01037 31.037 5.62517 31.1501C5.45872 31.1991 5.27283 31.1731 5.13841 31.0718C4.75595 30.7838 4.94923 29.7779 5.80148 29.4089C6.88972 28.9377 7.74032 28.1328 8.47786 27.2253C8.91206 26.6909 9.21896 26.3744 9.94719 26.4773C10.5287 26.5595 11.0781 26.6662 11.5186 26.1598C11.7043 25.9465 11.8329 25.7039 11.9526 25.4469C12.5201 24.0832 13.0698 23.2707 14.399 22.6073C14.4537 22.5799 14.4496 22.5 14.3924 22.4784C13.6398 22.1953 13.069 21.714 12.7112 21.0132C12.1204 19.8559 12.3137 18.4498 13.1741 17.4629C14.4532 15.996 16.8292 15.7937 18.1721 17.2047C19.3652 18.4583 18.6961 20.2356 17.8931 20.4705C17.6998 20.5272 17.97 19.9955 17.7327 19.6254C17.4455 19.1775 16.9311 18.9347 16.4027 18.9692C16.0178 18.9944 15.6912 19.2304 15.5409 19.5351C15.3632 19.8953 15.4138 20.3038 15.6446 20.6173C16.0939 21.2278 17.1055 21.4027 17.8192 21.4022L19.11 21.4011C19.847 21.4005 20.5446 21.4865 21.2827 21.5673C22.5921 21.7102 23.8764 21.6573 25.151 21.3305C26.619 20.954 27.8449 20.1743 29.0602 19.3067L30.3891 18.3584C30.9054 17.9899 31.4511 17.7339 32.0356 17.493C32.2644 17.3986 32.4717 17.277 32.6567 17.1292C32.8476 16.977 32.9647 16.8294 33.1922 16.5417C33.3373 16.3582 33.6875 15.9019 34.0417 15.5919C34.1009 15.5402 34.2077 15.451 34.3237 15.4753C34.5564 15.5243 34.5348 15.8567 34.5542 16.0385C34.5718 16.2005 34.5893 16.3626 34.6065 16.5247C34.6082 16.5397 34.618 16.5523 34.6331 16.5578C34.6506 16.5641 34.6703 16.5573 34.6802 16.5414C34.8061 16.338 34.9222 16.1274 35.0695 15.9385C35.1557 15.8282 35.2562 15.722 35.3652 15.6341C35.4101 15.598 35.4769 15.5405 35.539 15.541C35.7183 15.5429 35.7049 16.0168 35.7066 16.1321C35.7098 16.3695 35.7011 16.6131 35.7714 16.8428C35.8401 17.0673 35.9883 17.2463 36.1898 17.3657C36.5355 17.5705 36.8183 17.8629 36.9736 18.2355C37.1269 18.6032 36.9547 18.9328 37.5296 19.2131L38.824 19.8444C38.9852 19.923 39.0687 20.0919 38.9885 20.2677C38.6923 20.9162 38.0224 21.3058 37.3048 21.2379C36.6105 21.1722 35.4385 20.8708 34.8691 21.239C33.9227 21.8509 33.3869 23.0659 33.1974 24.1484C33.1369 24.4931 33.043 24.8095 32.8999 25.1307C32.8782 25.1791 32.9157 25.2331 32.9686 25.2298C33.046 25.2248 33.1257 25.2216 33.2013 25.2303C34.255 25.3532 35.2822 25.5148 36.2941 25.8285C36.7663 25.975 37.1879 26.1715 37.6418 26.3574C38.3284 26.6386 39.003 26.8765 39.7244 27.0528C40.0228 27.1259 40.3021 27.2083 40.5906 27.3063C40.8077 27.3802 40.9134 27.617 40.8159 27.8339C40.6191 28.2714 39.8777 28.3751 39.4402 28.3554C37.477 28.267 36.9018 27.1694 34.7927 27.2283L33.5703 27.2625L33.1785 27.2811C33.1096 27.2844 33.0855 27.375 33.1443 27.4114C34.1036 28.0077 35.0906 28.3609 35.9562 29.0576C36.6149 29.5877 37.3207 30.0156 38.1114 30.3203C38.415 30.4374 38.7008 30.5584 38.9718 30.7178C39.173 30.836 39.2212 31.0778 39.0942 31.2648C38.7906 31.7116 37.9892 31.7143 37.491 31.584C36.9098 31.432 36.3836 31.1804 35.8872 30.8456L34.9364 30.2042C34.4601 29.8828 33.9062 29.7286 33.3434 29.5942L31.3697 29.1236C30.9366 29.0204 30.5465 28.866 30.1408 28.6935C29.6513 28.4855 29.2675 28.1457 28.9827 27.6937C28.9644 27.6647 28.9285 27.6526 28.8965 27.6652C26.4887 28.6199 23.4501 27.786 21.1595 26.8434C20.6021 26.614 20.0669 26.4094 19.4829 26.2819C18.5006 26.0675 18.0511 26.2674 17.284 26.83C16.5388 27.3764 15.7405 27.8478 14.9002 28.2322C13.9196 28.6809 12.8322 29.2537 12.0065 29.9334C11.0666 30.7074 10.46 31.4857 9.43661 32.218C9.18939 32.3949 8.93615 32.5041 8.66348 32.586C8.65663 32.5879 8.64979 32.589 8.64267 32.589L8.64295 32.5904Z" /><path d="M24.8025 34.4478H26.1298V42.08H24.8025V38.6953H21.1301V42.08H19.8028V34.4478H21.1301V37.567H24.8025V34.4478Z" /><path d="M24.8025 5.77539H26.1298V13.4077H24.8025V10.0229H21.1301V13.4077H19.8028V5.77539H21.1301V8.89467H24.8025V5.77539Z" /></svg></div>`;
var ScrollingMarquee = class extends window.HTMLElement {
	spMarquee = null;
	connectedCallback() {
		if (/complete|interactive|loaded/.test(document.readyState)) this.init();
		else {
			this._initBound = this.init.bind(this);
			window.addEventListener("DOMContentLoaded", this._initBound, { once: true });
		}
	}
	init() {
		if (!this.isConnected) return;
		const raw = this.dataset.content ?? "";
		if (raw.includes("|||")) this.dataset.content = raw.split("|||").join(DOG_SEPARATOR);
		this.spMarquee = new SuperMarquee(this, { license: "4D611568-C282482B-9BE4CE50-6A6D1BFB" });
		requestAnimationFrame(() => this.classList.remove("opacity-0"));
	}
	disconnectedCallback() {
		window.removeEventListener("DOMContentLoaded", this._initBound);
		if (this.spMarquee) this.spMarquee.destroy();
	}
};
window.customElements.define("scrolling-marquee", ScrollingMarquee);
//#endregion
